/* eslint-disable react/no-danger */
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import React from 'react';

import { getImageAtSize } from '../../lib/utils';

import Body from '../typography/Body';

import styles from '../../../styles/blocks/image.module.css';

const propTypes = {
    image: PropTypes.shape({
        url: PropTypes.string,
        alt: PropTypes.string,
    }).isRequired,
    size: PropTypes.oneOf(['small', 'medium', 'large', 'full']),
    caption: PropTypes.string,
    author: PropTypes.string,
    url: PropTypes.string,
    external: PropTypes.bool,
    withSize: PropTypes.bool,
    padded: PropTypes.bool,
    className: PropTypes.string,
    imgClassName: PropTypes.string,
    captionClassName: PropTypes.string,
    isContainer: PropTypes.bool,
    containerClassName: PropTypes.string,
};

function ImageBlock({
    image = null,
    size = null,
    caption = null,
    author = null,
    url = null,
    external = true,
    withSize = false,
    padded = false,
    className = null,
    imgClassName = null,
    captionClassName = null,
    isContainer = false,
    containerClassName = null,
}) {
    if (image === null) {
        return null;
    }

    const { alt = null } = image;
    const {
        width = 0,
        height = 0,
        url: imageUrl = null,
    } = getImageAtSize(image, size === null || size === 'full' ? 'xlarge' : 'large', false);
    const hasSize = withSize && width !== 0 && height !== 0;

    const imageElement = (
        <img
            className={classNames([styles.image, { [imgClassName]: imgClassName !== null }])}
            src={imageUrl}
            alt={alt || caption}
            width={hasSize ? width : null}
            height={hasSize ? height : null}
        />
    );

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles[size]]: size !== null,
                    [styles.padded]: padded,
                    [className]: className !== null,
                },
            ])}
        >
            <div
                className={classNames([
                    styles.inner,
                    {
                        [styles.isContainer]: isContainer,
                        [containerClassName]: isContainer && containerClassName !== null,
                    },
                ])}
            >
                <div
                    className={styles.shape}
                    style={{
                        paddingBottom: hasSize ? `${(height / width) * 100}%` : null,
                    }}
                >
                    {url !== null ? (
                        <a
                            className={styles.link}
                            href={url}
                            target={external ? '_blank' : null}
                            rel={external ? 'noopener noreferrer' : null}
                        >
                            {imageElement}
                        </a>
                    ) : (
                        imageElement
                    )}
                </div>
                {!isEmpty(caption) ? (
                    <div
                        className={classNames([
                            styles.caption,
                            { [captionClassName]: captionClassName !== null },
                        ])}
                    >
                        <Body className={styles.title} body={caption} />
                    </div>
                ) : null}
                {!isEmpty(author) ? (
                    <div className={styles.author}>
                        <Body className={styles.author} body={author} />
                    </div>
                ) : null}
            </div>
        </div>
    );
}

ImageBlock.propTypes = propTypes;

export default ImageBlock;
